/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_PodInputs */

const en_svtag_pod = /** @type {(inputs: Svtag_PodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POD`)
};

const ar_svtag_pod = /** @type {(inputs: Svtag_PodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#طباعة`)
};

const bn_svtag_pod = /** @type {(inputs: Svtag_PodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POD`)
};

const de_svtag_pod = /** @type {(inputs: Svtag_PodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POD`)
};

const es_svtag_pod = /** @type {(inputs: Svtag_PodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POD`)
};

const fr_svtag_pod = /** @type {(inputs: Svtag_PodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POD`)
};

const pt_svtag_pod = /** @type {(inputs: Svtag_PodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POD`)
};

const zh_svtag_pod = /** @type {(inputs: Svtag_PodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POD`)
};

const tr_svtag_pod = /** @type {(inputs: Svtag_PodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POD`)
};

const ru_svtag_pod = /** @type {(inputs: Svtag_PodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POD`)
};

const pl_svtag_pod = /** @type {(inputs: Svtag_PodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POD`)
};

/**
* | output |
* | --- |
* | "#POD" |
*
* @param {Svtag_PodInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_pod = /** @type {((inputs?: Svtag_PodInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_PodInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_pod(inputs)
	if (locale === "bn") return bn_svtag_pod(inputs)
	if (locale === "de") return de_svtag_pod(inputs)
	if (locale === "es") return es_svtag_pod(inputs)
	if (locale === "fr") return fr_svtag_pod(inputs)
	if (locale === "pt") return pt_svtag_pod(inputs)
	if (locale === "zh") return zh_svtag_pod(inputs)
	if (locale === "tr") return tr_svtag_pod(inputs)
	if (locale === "ru") return ru_svtag_pod(inputs)
	if (locale === "pl") return pl_svtag_pod(inputs)
	return en_svtag_pod(inputs)
});